import * as React from "react";
// import { Link } from "gatsby"

import Layout from "../components/layout";
import HeroSection from "../components/OurServices/HeroSection";
import TransitStorage from "../components/OurServices/TransitStorage";
import Seo from "../components/seo";

const OurServices = () => (
  <Layout>
    <Seo title="Our Services" />
    <HeroSection />
    <TransitStorage />
  </Layout>
);

export default OurServices;
